// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

import tippy from 'vue-tippy';

// Vue Components
import pdpContainer from '@/components/containers/pdp/PdpContainer';

// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import '@/vendor/jquery.magnific-popup.min';

// Legacy Modules
import slider from '@/modules/slider';
import player from '@/modules/Players';
import productTile from '@/modules/ProductTile';
import pdpModule from '@/modules/pdp';
import powerReviews from '@/modules/powerReviews';

// Styling
import '@sassRoot/entryPoints/b2c/pdp.scss';
import pdpAccordionModule from '../../modules/pdpAccordion';

class Pdp extends Shell {
  loadPlugins() {
    // Load common plugins from Shell
    super.loadPlugins();

    this.loadTippy();
  }

  loadTippy() {
    this.vue.use(tippy, {
      animateFill: false,
      arrow: true,
      theme: 'light',
      flipDuration: 0,
      flip: true,
      flipBehavior: ['top', 'right', 'bottom'],
      popperOptions: {
        modifiers: {
          preventOverflow: {
            enabled: true,
          },
        },
      },
    });
  }
}

const pdp = new Pdp({pdpContainer});
pdp.preLoadInits();
pdp.initializeVue();

// Legacy foundation initialization
$(document).foundation();

const initPdp = () => {
  if ($('[data-pdp]').length) {
    pdpModule($(document));
  }
  pdpAccordionModule();
};

$(document).ready(() => {
  pdp.globalDocumentReadyInits();

  window.addEventListener('init-pdp', initPdp);

  // PDP Sliders
  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  // PDP Videos
  player();

  // Full reviews and FAQs
  if ($('[data-powerreviews]').length) {
    powerReviews($('[data-powerreviews]'));
  }

  // Color Swatches for carousels (More Options, etc)
  if ($('.product-tile').length) {
    productTile($(document));
  }
});

$(window).on('load', () => {
  pdp.globalOnLoadInits();
  initPdp();
});
